<template>
    <div class="order-page">
        <div class="order-page__inner">
            <div class="header header__offset">   
                <router-link 
                    to="/order"
                    class="news-page__create"></router-link>

                <router-link 
                    v-if="this.role == 'ADMIN'"
                    to="/create" 
                    class="admin-link__link">Создать пользователя</router-link>

                <span class="header__role" @click="exit">{{userName}}</span>
            </div>
            
            <h1 class="order-page__heading" id="top">Текущие обращения</h1>

            

            <Order 
                v-for="order in ORDERS"
                :key="order.id"
                :order_data="order"
                @openOrder="openOrder"
                />

            <div class="pagination order-page__pagination">
                <a href="#top" 
                class="page"
                v-for="page in TOTAL_PAGES"
                :key="page"
                :class="{page__selected:page === this.$store.state.page}"
                @click="pageClick(page)">{{page}}</a>
            </div>

            <div class="navigation order-page__navigation">
                <router-link to="/news" 
                    class="navigation__link navigation__link_news">Новости</router-link>
                <a 
                    href="#" 
                    class="navigation__link navigation__link_now active">Текущие</a>
                <router-link to="/archive" 
                    class="navigation__link navigation__link_archive">Архив</router-link>

                <router-link to="/payment" 
                    class="navigation__link navigation__link_payment">Оплата</router-link>
                
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions ,mapGetters} from 'vuex'
import Order from '@/components/Order'
import Filters from '@/components/filters/Filters'
import axios from 'axios'

export default {
    data() {
        return {
            role: '',
            userName: '',
            searchValue: '',
            guesses: '',
            sortSearch: 'num',
            isNumber: true,
            isYpd: false,
            isDate: false,
            isFiltersOpened: false
        }
    },
    components:{
        Order,
        Filters
    },
    methods: {
        ...mapActions([
            'GET_ORDERS',
            'GET_PAGE_NUMBER',
            'RESET_PAGE_NUMBER',
            'SEARCH_CUR_ORDER',
            'IS_ARCHIVE',
            'GET_EMPLOYEES',
            'GET_SORT_SEARCH'
        ]),
        openOrder(id){
            this.$router.push({name: 'curorder', query: {'curorder': id}})
        },
        openFilters(){
            this.isFiltersOpened = !this.isFiltersOpened
        },
        exit(){
            let isExit = confirm("Выйти?");
            if(isExit){
                document.cookie = `token = ''; max-age=-1`
                this.$router.push('/login')
            } 
        },
        pageClick(page){
            this.GET_PAGE_NUMBER(page)
            this.GET_ORDERS()
        },
        getRole(){
            this.role = localStorage.getItem('role')
            this.userName = localStorage.getItem('name')
        },
        selectNumber(){
            this.isNumber = true
            this.isYpd = false
            this.isDate = false
            this.sortSearch = 'num'
            this.GET_SORT_SEARCH('num')
        },
        selectYpd(){
            this.isYpd = true
            this.isNumber = false
            this.isDate = false
            this.sortSearch = 'ypd'
            this.GET_SORT_SEARCH('ypd')
        },
        selectDate(){
            this.isDate = true
            this.isYpd = false
            this.isNumber = false
            this.sortSearch = 'date'
            this.GET_SORT_SEARCH('date')
        },
        search(value){
            this.SEARCH_CUR_ORDER(value)
            this.searchValue = ''
        },
        getGuesses(){
            let cookie = document.cookie.match(/token=(.+?)(;|$)/);
            axios({
                method: 'GET',
                url: 'https://lk-berry1.ru:3000/api/order/getguess',
                headers: { Authorization: `Bearer ${cookie[1]}`},
                params: {
                    searchVal: this.searchValue,
                    isArchive: 0,
                    sort: this.sortSearch
                }
            }).then((res)=>{
                this.guesses = res.data
            })
        },
        selectGuess(val){
            this.searchValue = val
        }
    },
    computed: {
        ...mapGetters([
            'ORDERS',
            'TOTAL_PAGES'
        ])
    },
    mounted() {
        this.IS_ARCHIVE(0)
        // this.RESET_PAGE_NUMBER(1)
        this.GET_ORDERS(); 
        this.GET_EMPLOYEES()
        this.getRole()
        // window.scrollTo(0, 0)
    },
}
</script>

<style scoped>
    .order-page__inner{
        padding: 10px 15px;
        padding-bottom: 80px;
        max-width: 600px;
        margin: 0 auto;
        border: 2px solid #000;
        border-radius: 2px;
        margin-top: 15px;
        background-color: #eee;
    }
    .news-page__create{
        display: block;
        box-shadow: 4px 4px 10px rgb(0 0 0 / 25%);
        background: url(../images/add.png) no-repeat;
        height: 40px;
        width: 40px;
        background-size: 40px 40px;
        border-radius: 50%;
    }
    .admin-link{
        text-align: right;
        border-bottom: 1px solid #000;
    }
    .admin-link__link{
        display: inline-block;
        text-decoration: none;
        margin-top: 15px;
        margin-bottom: 15px;
        padding: 10px;
        background-color: #009ED2;
        color: #fff;
        border-radius: 5px;
        margin-left: 25px;
    }
    .header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #000;
    }
    .header__offset{
        padding-bottom: 10px;
    }
    .order-page__left{
        display: flex;
        align-items: center;
    }
    .header__agent{
        position: relative;
        padding-top: 40px;
        font-size: 12px;
        color: #000;
        text-decoration: none;
    }
    .header__agent::before{
        position: absolute;
        content: "";
        height: 40px;
        width: 40px;
        top: 0;
        left: 50%;
        margin-left: -20px;
        background: url(../images/agent.png) no-repeat;
        background-size: cover;
    }
    .header__support{
        position: relative;
        padding-top: 40px;
        font-size: 12px;
        color: #000;
        text-decoration: none;
        margin-right: 20px;
    }
    .header__support::before{
        position: absolute;
        content: "";
        height: 40px;
        width: 40px;
        top: 0;
        left: 15px;
        background: url(../images/support-ico.png) no-repeat;
        background-size: cover;
    }
    .header__role{
        position: relative;
        padding: 15px 45px 15px 0;
        margin-left: auto;
    }
    .header__role::after{
        position: absolute;
        content: "";
        height: 35px;
        width: 35px;
        right: 0;
        top: 50%;
        margin-top: -20px;
        background: url(../images/exit.png) no-repeat;
        background-size: contain;
    }
    .order-page__heading{
        text-align: center;
        margin-top: 15px;
    }
    .search{
        position: relative;
        height: 100%;
        width: 100%;
        margin-bottom: 25px;
    }
    .search-inner{
        display: flex;
        border: 1px solid #000;
        border-radius: 5px;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .search__checkboxes{
        display: flex;
        justify-content: space-between;
    }
    .order-page__filters-btn{
        background: none;
        font-size: 14px;
        padding: 15px 30px;
        border: 1px solid #000;
        margin-bottom: 15px;
    }
    .order-page__filters-btn:hover{
        background-color: #d8d8d8;
    }
    .search__field{
        border: none;
        border-radius: 5px 0 0 5px;
        padding: 15px 25px 15px 20px;
        width: 100%;
        height: 100%;
        transition: all linear .1s;
    }
    .search__field:focus{
        outline: none;
    }
    .search__button{
        background: none;
        border: none;
        border-left: 1px solid #000;
        width: 55px;
        background: url(../images/search-ico.png) no-repeat;
        background-position: center;
        background-size: 30px 30px;
        border-radius: 0 5px 5px 0;
    }
    .search__button:hover{
        cursor: pointer;
    }
    .search__guesses{
        position: absolute;
        background-color: #fff;
        box-shadow: 0 10px 20px rgb(0 0 0 / 50%);
        padding: 15px;
        width: 100%;
        z-index: 100;
        max-height: 330px;
        overflow-y: scroll;
    }
    .search__guess{
        margin-top: 15px;
        font-size: 14px;
        padding: 5px;
    }
    .search__guess:hover{
        cursor: pointer;
        background-color: #b6b4b4;
    }
    .pagination{
        display: flex;
        justify-content: center;
    }
    .order-page__pagination{
        margin-top: 25px;
        margin-bottom: 25px;
    }
    .page{
        height: 40px;
        width: 40px;
        line-height: 40px;
        background-color: #D8D8D8;
        text-align: center;
        margin-right: 10px;
        transition: all linear .2s;
        border-radius: 5px;
        color: #000;
        text-decoration: none;
    }
    .page:hover{
        cursor: pointer;
        background-color: #b6b4b4;
    }
    .page__selected{
        background-color: #b6b4b4;
    }

    .order-page__navigation{
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        background-color: #eee;
        border-top: 1px solid #d8d8d8;
    }
    .navigation__link{
        flex-basis: 33.333%;
        position: relative;
        padding: 50px 25px 10px;
        font-size: 12px;
        text-decoration: none;
        color: #000;
        border-right: 1px solid #d8d8d8;
        text-align: center;
    }
    .navigation__link::before{
        position: absolute;
        content: "";
        width: 40px;
        height: 40px;
        top: 5px;
        left: 50%;
        margin-left: -20px;
    }
    .navigation__link:last-child{
        border-right: none;
    }
    .navigation__link_news::before{
        background: url(../images/news-ico.svg) no-repeat;
        background-size: contain;
        background-position: center;
    }
    .navigation__link_now::before{
        background: url(../images/now2.png) no-repeat;
        background-size: contain;
        background-position: center;
    }
    .navigation__link_add::before{
        background: url(../images/add4.png) no-repeat;
        background-size: contain;
        background-position: center;
    }
    .navigation__link_archive::before{
        background: url(../images/archive.png) no-repeat;
        background-size: contain;
        background-position: center;
    }
    .navigation__link_payment::before{
        background: url(../images/payment.svg) no-repeat;
        background-size: contain;
        background-position: center;
    }
    .active{
        background-color: #d8d8d8;
        pointer-events: none;
    }
    .filterActive{
        background-color: #d8d8d8;
    }
    @media (max-width: 600px) {
        .header__role{
            font-size: 14px;
            max-width: 250px;
        }
        .admin-link__link{
            font-size: 14px;
            margin-left: 15px;
        }
        .search__checkboxes{
            flex-direction: column;
        }
        .checkbox__wrapper{
            margin-bottom: 25px;
        }
        .order-page__heading{
            font-size: 26px;
        }
    }
</style>